import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "gfu-announcement-box" }
const _hoisted_2 = {
  class: "gfu-base-carousel-indicators",
  role: "tablist"
}
const _hoisted_3 = ["aria-selected", "onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_announcement_box_content = _resolveComponent("announcement-box-content")
  const _component_base_carousel_navigation = _resolveComponent("base-carousel-navigation")
  const _component_base_carousel = _resolveComponent("base-carousel")
  const _component_intersection_trigger = _resolveComponent("intersection-trigger")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_intersection_trigger, { onIntersected: $options.onIntersected }, {
      default: _withCtx(() => [
        _createVNode(_component_base_carousel, {
          class: "gfu-announcement-box__slider",
          autoplay: true,
          "max-indicators": 9,
          "autoplay-speed": 15000,
          "stop-on-hover": true,
          role: "region",
          "aria-roledescription": "carousel",
          onChange: $options.onSlideChange
        }, {
          default: _withCtx(({ onAction, currentItem }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredBanners, ({actionUrl, item}, index) => {
              return (_openBlock(), _createBlock(_component_announcement_box_content, {
                key: index,
                slide: item,
                "action-url": actionUrl,
                class: _normalizeClass(['gfu-base-carousel-slide', { 'is-active': index === currentItem }]),
                onClick: onAction
              }, null, 8 /* PROPS */, ["slide", "action-url", "class", "onClick"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          indicators: _withCtx(({ onSetCurrentIndex, currentItem, indicators }) => [
            _createElementVNode("nav", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(indicators, (item, index) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: index,
                  href: "#",
                  class: _normalizeClass(['gfu-base-carousel-indicators__indicator', {'is-active': index === currentItem}]),
                  role: "tab",
                  "aria-selected": index === currentItem,
                  onClick: _withModifiers($event => (onSetCurrentIndex(index)), ["prevent"])
                }, _toDisplayString(index), 11 /* TEXT, CLASS, PROPS */, _hoisted_3))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          nav: _withCtx(({ onNext, onPrev }) => [
            _createVNode(_component_base_carousel_navigation, {
              type: "prev",
              icon: "angle-left",
              class: "gfu-announcement-box-slider-nav gfu-announcement-box-slider-nav--prev",
              "has-icon-base-class": false,
              "aria-label": "Previous slide",
              onClick: $event => ($options.onNavClick(onPrev))
            }, null, 8 /* PROPS */, ["onClick"]),
            _createVNode(_component_base_carousel_navigation, {
              type: "next",
              icon: "angle-right",
              "has-icon-base-class": false,
              class: "gfu-announcement-box-slider-nav gfu-announcement-box-slider-nav--next",
              "aria-label": "Next slide",
              onClick: $event => ($options.onNavClick(onNext))
            }, null, 8 /* PROPS */, ["onClick"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onChange"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onIntersected"])
  ]))
}